import "../styles/general.css";
import "../styles/queries.css";
import "../styles/AddHabitScoreCard.css";

function AddHabitScoreCard({ habitName, habitID, inputChangeHandler }) {
  return (
    <>
      <span className="habit-name">{habitName}</span>
      <input
        id="units-completed"
        type="number"
        name="unitsCompleted"
        placeholder="2"
        required
        onChange={(e) => inputChangeHandler(e, habitID)}
      />
    </>
  );
}

export default AddHabitScoreCard;
